import React, { useRef, useState } from 'react';
import useFullscreen from '../hooks/useFullscreen';
import useIframeWatchdog from '../hooks/useIframeWatchdog';

function Office313() {
    const pageRef = useRef(null);
    const playerRef = useRef(null);
    const [isMuted, setIsMuted] = useState(false);
    const { isFullscreen, toggleFullscreen } = useFullscreen(pageRef);
    const videoId = '1kNGcR9HYVg';
    const src = `https://www.youtube.com/embed/${videoId}?autoplay=1&loop=1&playlist=${videoId}&controls=0&modestbranding=1&rel=0&playsinline=1&enablejsapi=1`;
    const { iframeSrc } = useIframeWatchdog(src);

    const toggleMute = () => {
        const nextMuted = !isMuted;
        const command = nextMuted ? 'mute' : 'unMute';

        playerRef.current?.contentWindow?.postMessage(
            JSON.stringify({
                event: 'command',
                func: command,
                args: [],
            }),
            '*'
        );

        setIsMuted(nextMuted);
    };

    return (
        <div
            ref={pageRef}
            className="office313-video-page"
            onDoubleClick={toggleFullscreen}
        >
            <iframe
                ref={playerRef}
                className="office313-video-frame"
                src={iframeSrc}
                title="313 Office video"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
            />
            <button
                type="button"
                className="mute-toggle-button"
                onClick={toggleMute}
                aria-label={isMuted ? 'Unmute video' : 'Mute video'}
            >
                {isMuted ? 'UNMUTE' : 'MUTE'}
            </button>
            <button
                type="button"
                className="fullscreen-toggle-button"
                onClick={toggleFullscreen}
                aria-label={isFullscreen ? 'Exit fullscreen' : 'Enter fullscreen'}
            >
                {isFullscreen ? 'EX' : 'FS'}
            </button>
            <style>{`
                .office313-video-page {
                    position: fixed;
                    inset: 0;
                    background: #000;
                    overflow: hidden;
                }

                .office313-video-frame {
                    position: absolute;
                    inset: 0;
                    width: 100%;
                    height: 100%;
                    border: 0;
                }

                .fullscreen-toggle-button {
                    position: absolute;
                    top: 12px;
                    right: 12px;
                    z-index: 3;
                    width: 34px;
                    height: 34px;
                    border: 1px solid rgba(255, 255, 255, 0.75);
                    border-radius: 6px;
                    background: rgba(0, 0, 0, 0.45);
                    color: #fff;
                    font-size: 11px;
                    font-weight: 700;
                    letter-spacing: 0.5px;
                    cursor: pointer;
                    padding: 0;
                }

                .mute-toggle-button {
                    position: absolute;
                    top: 12px;
                    right: 58px;
                    z-index: 3;
                    height: 34px;
                    border: 1px solid rgba(255, 255, 255, 0.75);
                    border-radius: 6px;
                    background: rgba(0, 0, 0, 0.45);
                    color: #fff;
                    font-size: 11px;
                    font-weight: 700;
                    letter-spacing: 0.5px;
                    cursor: pointer;
                    padding: 0 10px;
                }
            `}</style>
        </div>
    );
}

export default Office313;
